// import { fetcher } from '@/lib/fetcher';
// import BannerSlider from './BannerSlider';

// const Banner = async () => {
//   // CORRECT: Fetch ONLY the data this component needs from a fast, dedicated endpoint.
//   const sliders = await fetcher('/api/v2/home-things?for=desktop'); // <-- CHANGE THIS ENDPOINT

//   // The loading/skeleton state is now handled by Suspense in page.js
//   if (!sliders || sliders.length === 0) {
//     // Render nothing if there are no slides. The parent page won't show an empty section.
//     return null;
//   }

//   return (
//     <section className="banner padding-top--style2">
//       <div className="container">
//         <div className="row">
//           <div className="col-12">
//             <BannerSlider sliders={sliders?.sliders} />
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Banner;

'use client'; // <-- CRITICAL: Make this a client component

import React, { useState, useEffect } from 'react';
import BannerSlider from './BannerSlider';
import { BannerSkeleton } from './BannerSkeleton'; // Import your existing skeleton
import { useFetcherCSR } from '@/lib/useFetcherCSR';

export default function Banner() {
  const { data, isLoading } = useFetcherCSR('/api/v2/home-things?for=desktop');
  const [isMobile, setIsMobile] = useState(false);
  const desktopSlider = data?.sliders;
  const mobileSlider = data?.mobile_sliders;

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    setIsMobile(isMobile);
  }, []);

  // --- RENDER LOGIC ---

  // 1. While fetching, show the skeleton component.
  if (isLoading) {
    return <BannerSkeleton />;
  }

  // 3. Once data is available, render the full banner with the slider.
  return (
    <section className="banner padding-top--style2">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <BannerSlider sliders={isMobile ? mobileSlider : desktopSlider} />
          </div>
        </div>
      </div>
    </section>
  );
}
